import React from 'react';
import { XIcon } from 'lucide-react';
import { Pill } from './Pill';
import { painPoints } from '../data/copy';
export function PainSection() {
  return <section className="w-full bg-cream py-10 sm:py-12" aria-labelledby="pain-heading" data-id="element-119" data-mp="38vu8yc6q8d5p">
      <div className="mx-auto max-w-5xl px-6" data-id="element-120" data-mp="2uxvw5b820osb">
        <div className="text-center" data-id="element-121" data-mp="2yzh7ut8uqx0x">
          <Pill tone="rose" data-id="element-122" data-mp="2yyfw0mk0i6i5">A familiar Sunday night</Pill>
          <h2 id="pain-heading" className="mt-5 font-display text-4xl leading-tight text-charcoal sm:text-5xl" data-id="element-123" data-mp="2l8m0xmhwypzz">
            Does this sound familiar?
          </h2>
        </div>

        <div className="mx-auto mt-6 max-w-2xl rounded-3xl border border-rose-deep/20 bg-blush p-6 text-center sm:p-8" data-id="element-124" data-mp="2q0vmkqbzx3wg">
          <p className="font-display text-2xl leading-snug text-charcoal" data-id="element-125" data-mp="2g8pz9twovanl">
            <span className="text-wine" data-id="element-126" data-mp="2g6woq3iyg6ab">Sunday night, 10:00 PM.</span> Classes
            tomorrow — and you’re still hunting for combinations that flow.
          </p>
          <p className="mt-4 font-sans text-base leading-relaxed text-ash" data-id="element-127" data-mp="2781ln0b7jcb8">
            You know ballet. You love teaching. Nobody ever gave you a{' '}
            <span className="font-medium text-wine" data-id="element-128" data-mp="3nlp9hts1cz5u">
              complete, ready-to-teach infrastructure.
            </span>
          </p>
        </div>

        <h3 className="mt-10 text-center font-display text-3xl leading-tight text-charcoal" data-id="element-129" data-mp="5f17icsa8s4e">
          The cost of improvising is{' '}
          <span className="text-wine" data-id="element-130" data-mp="38w9oyvj3lpyl">high:</span>
        </h3>

        <ul className="mx-auto mt-6 grid max-w-4xl gap-3 sm:grid-cols-2" data-id="element-131" data-mp="38wsu1bnngjv7">
          {painPoints.map(point => <li key={point} className="flex items-start gap-3 rounded-2xl border border-rose-deep/20 bg-rose-light/40 px-5 py-4" data-id="element-132" data-mp="33z9hcg6lof5d">
              <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-rose-deep" strokeWidth={2.2} aria-hidden="true" data-id="element-133" data-mp="3dvm752z0y8uu" />
              <span className="font-sans text-[0.9rem] leading-relaxed text-charcoal/85" data-id="element-134" data-mp="2q5i715l1or8l">
                {point}
              </span>
            </li>)}
        </ul>

        <p className="mx-auto mt-8 max-w-3xl rounded-3xl bg-wine px-8 py-7 text-center font-display text-xl leading-snug text-cream sm:text-2xl" data-id="element-135" data-mp="2l4ugsm4n4eff">
          It’s time to stop giving away your free time. Your dedication is
          already there. What you need now is the right tool.
        </p>
      </div>
    </section>;
}